import { useFilterConfigs } from '@/productDiscovery/Listings/hooks/useFiltersConfig';

export const useOrderedFilterConfigs = () => {
  const filterConfigs = useFilterConfigs();
  return filterConfigs.filter(
    (filterConfig) =>
      ![
        'has_1day_delivery',
        'has_relay_delivery',
        'has_free_delivery',
        'is_mmf',
      ].includes(filterConfig.attributeName),
  );
};
